const STORAGE_KEY_PREFIX = "poca:selected-group:";

function storageKey(): string {
  return `${STORAGE_KEY_PREFIX}${window.location.pathname}`;
}

/** 마지막으로 선택한 컬렉션 handle (그룹). URL에 group 파라미터가 없을 때 복원용 */
export function readCachedGroupHandle(): string | null {
  try {
    const raw = localStorage.getItem(storageKey());
    const handle = raw?.trim();
    return handle || null;
  } catch {
    return null;
  }
}

export function writeCachedGroupHandle(handle: string | null): void {
  try {
    const key = storageKey();
    if (!handle?.trim()) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, handle.trim());
  } catch {
    /* private mode / quota — ignore */
  }
}
